import { render, staticRenderFns } from "./ReportShengFuBao.vue?vue&type=template&id=cb788106&scoped=true"
import script from "./ReportShengFuBao.vue?vue&type=script&lang=js"
export * from "./ReportShengFuBao.vue?vue&type=script&lang=js"
import style0 from "./ReportShengFuBao.vue?vue&type=style&index=0&id=cb788106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb788106",
  null
  
)

export default component.exports